import styled from 'styled-components';
export const Button = styled.button `
  background-color: #51b651;
  border: none;

  border-radius: ${(props) => (props.circular ? '50%' : 'none')};

  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.46);
  color: white;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  user-select: none;

  width: 20px;
  height: 20px;
  font-size: 1rem;
  line-height: 20px;

  // with icon
  align-items: center;
  display: flex;
  justify-content: center;
`;
//# sourceMappingURL=Button.js.map